/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import {useListBatchContactImports} from '@agent-assist/api-typescript-react-query-hooks';
import {useEffect, useState} from 'react';
import {useContactImportsStore} from '../stores/contactImportsStore';

export const useUpdateContactImports = () => {
  const [flagHasUpdated, setFlagHasUpdated] = useState(false);

  const setContactImports = useContactImportsStore((state) => state.setContactImports);
  const listContactImports = useListBatchContactImports({
    pageSize: 1000, // Pagination not on this component. Shifting to Continuous Ingestion and "Streams" in the future.
  });

  useEffect(() => {
    if (!flagHasUpdated && listContactImports.data?.pages.length) {
      const contactImports = (listContactImports.data?.pages?.flatMap?.((p: any) => p.imports) ?? []).filter(
        ({status}) => status === 'SUCCESS',
      );

      setContactImports(contactImports);

      setFlagHasUpdated(true);
    }
  }, [listContactImports]);
};
